import { c as _c } from "react/compiler-runtime";
import { Separator, VStack } from '@chakra-ui/react';
import { Hero } from '@src/components/sco/LayoutBlocks/Hero';
import SectionWrapper from '@src/components/sco/LayoutBlocks/SectionWrapper';
import { CustomersBlock } from '@src/components/sco/SuccessLP/CustomersBlock';
import { FoundersBlock } from '@src/components/sco/SuccessLP/FoundersBlock';
import { FundingBlock } from '@src/components/sco/SuccessLP/FundingBlock';
import { QuoteBlock } from '@src/components/sco/SuccessLP/QuoteBlock';
import { TestimonialsBlock } from '@src/components/sco/SuccessLP/TestimonialsBlock';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { SSRGate } from '@src/components/sco/utilities/SSRGate';
export const SuccessLP: React.FC = () => {
  const $ = _c(29);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Hero configKey="successLanding" heroBoxProps={{
      paddingBottom: 0,
      bgColor: "colorPalette.panel"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Separator width="full" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = require("@public/assets/graphics/avatars/andrew-gazdecki-avatar.jpg");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = t2.default.src;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = require("@public/assets/graphics/client-logos/acquire-logo.svg");
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = isMobile ? 8 : 16;
  let t6;
  if ($[4] !== t5) {
    t6 = <QuoteBlock avatarUrl={t3} logoAlt="Owlet Logo" logoUrl={t4.default.src} logoWidth="180px" name="Andrew Gazdecki" title="Founder/CEO, Acquire.com" containerProps={{
      maxWidth: "container.lg",
      marginY: t5
    }} quote={"Startups.com, and especially Wil, is where I go when I need real founder-level perspective. It\u2019s the kind of insight only someone who\u2019s been through everything can give. Around here, we call him the startup god."} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FundingBlock />;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = require("@public/assets/graphics/avatars/jonathan-poma-loop.jpg");
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = t8.default.src;
  let t10;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = require("@public/assets/graphics/client-logos/loop-returns-logo.svg");
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  const t11 = t10.default.src;
  const t12 = isMobile ? false : true;
  let t13;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = require("@public/assets/graphics/social/jonathan-poma-cutout.png");
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  const t14 = isMobile ? 16 : 0;
  let t15;
  if ($[10] !== t14) {
    t15 = {
      maxWidth: "container.xl",
      marginTop: 16,
      marginBottom: t14
    };
    $[10] = t14;
    $[11] = t15;
  } else {
    t15 = $[11];
  }
  let t16;
  if ($[12] !== t12 || $[13] !== t15) {
    t16 = <QuoteBlock avatarUrl={t9} logoAlt="Owlet Logo" logoUrl={t11} logoWidth="140px" name="Jonathan Poma" secondaryCalloutText="$135M Raised" showVisual={t12} title="Founder, Loop Returns" visualAlt="Jonathan Poma Cutout" visualBgGradient="blue.muted" visualUrl={t13.default.src} containerProps={t15} quote={"Building a startup is incredibly lonely. Startups.com changed that for me. The community gave me a place to be understood, get real help, and support others. It\u2019s become a group I trust deeply - people who would drop anything to help."} />;
    $[12] = t12;
    $[13] = t15;
    $[14] = t16;
  } else {
    t16 = $[14];
  }
  let t17;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <CustomersBlock containerProps={{
      paddingBottom: 0
    }} />;
    $[15] = t17;
  } else {
    t17 = $[15];
  }
  let t18;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = require("@public/assets/graphics/avatars/danmartell.jpg");
    $[16] = t18;
  } else {
    t18 = $[16];
  }
  const t19 = t18.default.src;
  let t20;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = require("@public/assets/graphics/client-logos/saas-academy-logo.svg");
    $[17] = t20;
  } else {
    t20 = $[17];
  }
  let t21;
  let t22;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <QuoteBlock avatarUrl={t19} logoAlt="Owlet Logo" logoUrl={t20.default.src} logoWidth="250px" name="Dan Martell" title="Founder, SaaS Academy" containerProps={{
      maxWidth: "container.lg",
      marginY: 20
    }} quote="The worst thing you can do as a Founder is go it alone. This is the missing piece of the puzzle - a tribe that you can grow with." />;
    t22 = <FoundersBlock />;
    $[18] = t21;
    $[19] = t22;
  } else {
    t21 = $[18];
    t22 = $[19];
  }
  let t23;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = require("@public/assets/graphics/avatars/rashidali.jpg");
    $[20] = t23;
  } else {
    t23 = $[20];
  }
  const t24 = t23.default.src;
  let t25;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = require("@public/assets/graphics/chomps-logo.svg");
    $[21] = t25;
  } else {
    t25 = $[21];
  }
  let t26;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <QuoteBlock avatarUrl={t24} logoAlt="Owlet Logo" logoUrl={t25.default.src} logoWidth="180px" name="Rashid Ali" title="Founder, Chomps" containerProps={{
      maxWidth: "container.lg",
      marginY: 20
    }} quote="Startups.com is in a league of its own when it comes to the structure, technology, and most importantly, participants." />;
    $[22] = t26;
  } else {
    t26 = $[22];
  }
  let t27;
  if ($[23] !== t16 || $[24] !== t6) {
    t27 = <SectionWrapper bgColor="colorPalette.panel" gap={0}>{t1}{t6}{t7}{t16}{t17}{t21}{t22}{t26}</SectionWrapper>;
    $[23] = t16;
    $[24] = t6;
    $[25] = t27;
  } else {
    t27 = $[25];
  }
  let t28;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <SSRGate disableSSR={true}><TestimonialsBlock /></SSRGate>;
    $[26] = t28;
  } else {
    t28 = $[26];
  }
  let t29;
  if ($[27] !== t27) {
    t29 = <VStack align="stretch" gap={0} height="full" justify="stretch" width="full">{t0}{t27}{t28}</VStack>;
    $[27] = t27;
    $[28] = t29;
  } else {
    t29 = $[28];
  }
  return t29;
};